import { get, post, put } from '../Services/http';
import { catchError } from './Error.action';
import { setRequirePallet } from './Checkout.action'
import { show as showNotification } from './Notification.action';
import { addToCartEvent, removeFromCartEvent } from './Gtm.action';

export const CART_LOAD = 'CART_LOAD';
export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';
export const CART_HIDE = 'CART_HIDE';

export const load = () => (dispatch, getState) => {
    return get('/api/cart/load')
        .then(response => response.json())
        .then(cart => {
            dispatch(receive(cart))
        })
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
        ;
}

export const loadError = error => ({
    type: CART_LOAD_ERROR,
    payload: {
        error,
    }
})

export const receive = cart => {
    return ({
        type: CART_RECEIVE,
        payload: cart,
    })
}

export const toggle = () => (dispatch, getState) => {
    dispatch(show(!getState().cart.showInfo));
    if (!document.body.classList.contains('has-minicart-overlay')) {
        document.body.className += ' ' + 'has-minicart-overlay';
    }
    else {
        document.body.classList.remove('has-minicart-overlay');
    }
}

const show = visible => ({
    type: CART_SHOW_INFO,
    payload: {
        showInfo: visible,
    }
})

export const add = ({ articleNumber, quantity = 1, nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {
    return (dispatch) => {
        if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
            return;
        }
        return post('/api/cart/add', { articleNumber, quantity: parseInt(quantity) })
            .then(response => response.json())
            .then(cart => {
                dispatch(receive(cart));
                if (articleNumber != "0") {
                    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                    dispatch(addToCartEvent(articleNumber, quantity));
                }
            })
            .catch(ex => dispatch(catchError(ex, error => loadError(error))))
            ;
    }
}

export const reorder = ({ orderId, nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {
    if (orderId) {
        return (dispatch) => {
            return post('/api/cart/reorder', { orderId })
                .then(response => response.json())
                .then(cart => {
                    dispatch(receive(cart));
                    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                })
                .catch(ex => dispatch(catchError(ex, error => loadError(error))))
                ;
        }
    }
}

export const update = (rowSystemId, quantity, changeQuantity) => (dispatch) => {
    return put(`/api/cart/update`, { rowSystemId, quantity })
        .then(response => response.json())
        .then(cart => {
            dispatch(receive(cart))
            dispatch(setRequirePallet(cart.requirePallet))
            if (quantity > 0) {
                const payloadQuantity = Math.abs(changeQuantity);
                if (changeQuantity > 0) {
                    let articleNumber = (cart.orderRows.find(r => r.rowSystemId === rowSystemId) || {}).articleNumber;
                    dispatch(addToCartEvent(articleNumber, payloadQuantity));

                } else {
                    dispatch(removeFromCartEvent(rowSystemId, payloadQuantity));
                }
            }
        })
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}